import styled from '@emotion/styled'
import React from 'react'

export const NoResultsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;

  ${({ $margin }) => ($margin !== undefined ? `margin: ${$margin};` : '')}
  ${({ $padding }) =>
    $padding !== undefined ? `padding: ${$padding};` : ''}

  width: 100%;
  border-radius: 6px;
  border: 1px solid var(--geyser);
`

export const NoResultsText = styled.p`
  margin-bottom: 0;
  text-align: center;
`

export const NoResultsIconContainer = styled.div`
  font-size: 17px;
  width: 1em;
  height: 1em;
  color: var(--mine-shaft);
`

export const NoResultsIcon = () => (
  <svg
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
  >
    <path
      d='M2.038 16.952c-0.146 0.146-0.338 0.219-0.53 0.219s-0.384-0.073-0.53-0.219c-0.293-0.291-0.293-0.764 0-1.056l2.311-2.302c-2.452-1.568-3.289-3.738-3.289-4.64 0-1.951 3.154-6.722 9-6.722 2.251 0 3.671 0.68 4.456 1.236l2.521-2.511c0.293-0.292 0.767-0.292 1.061 0s0.292 0.765 0 1.056l-15 14.939zM6.984 9.914l2.984-2.972c-0.301-0.143-0.629-0.228-0.968-0.228-1.241 0-2.25 1.006-2.25 2.241 0 0.336 0.091 0.659 0.234 0.959zM9 3.726c-5.088 0-7.5 4.194-7.5 5.228 0 0.333 0.535 2.189 2.882 3.551l1.529-1.522c-0.053-0.049-0.114-0.085-0.152-0.149-0.333-0.568-0.509-1.217-0.509-1.879 0-2.059 1.682-3.734 3.75-3.734 0.742 0 1.455 0.226 2.065 0.629l1.306-1.301c-0.619-0.381-1.689-0.823-3.371-0.823zM8.999 12.689c-0.392 0-0.721-0.302-0.748-0.697-0.027-0.412 0.286-0.767 0.7-0.794 1.231-0.080 2.22-1.065 2.3-2.291 0.027-0.411 0.395-0.724 0.797-0.696 0.413 0.026 0.727 0.382 0.7 0.793-0.129 1.971-1.72 3.555-3.7 3.685-0.017 0.001-0.033 0.001-0.050 0.001zM6.931 13.936c0.654 0.163 1.351 0.247 2.069 0.247 5.088 0 7.5-4.193 7.5-5.228 0-0.312-0.325-1.327-1.329-2.469-0.273-0.311-0.242-0.783 0.071-1.054s0.785-0.24 1.058 0.071c1.033 1.174 1.7 2.53 1.7 3.453 0 1.951-3.154 6.722-9 6.722-0.842 0-1.662-0.098-2.436-0.293-0.402-0.1-0.645-0.507-0.545-0.907s0.509-0.643 0.911-0.541z'
      fill='currentColor'
    />
  </svg>
)
